
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  mounted() {
    const self = this,
          $ = this.$,
          app = this.$app;
    const latlng = this.$route.query.y && this.$route.query.x ? [this.$route.query.y, this.$route.query.x] : myApp.latlng;
    const map = new L.Map('explore-map', {
      zoomControl: false,
      minZoom: 1
    }).setView(latlng, 12);
    myApp.latlng = latlng;
    myApp.exploreMarkers = [];
    myApp.exploreMarkersObj = [];
    myApp.exploreMap = map;
    myApp.exploreGoToMap = this.goToMap;
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a class="external" target="_system" ' + 'href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    if (myApp.realPosition) {
      if (myApp.exploreMarker) {
        myApp.exploreMap.removeLayer(myApp.exploreMarker);
      }

      myApp.exploreMarker = L.marker(myApp.realPosition, {
        icon: myApp.GeoIcon
      });
      myApp.exploreMarker.addTo(map);
    } // imposta evento ricerca


    var autocomplete = new google.maps.places.AutocompleteService();
    $('#explore-input').on('keyup change', () => {
      const value = $('#explore-input').val();

      if (value.length > 1) {
        autocomplete.getPlacePredictions({
          input: value,
          types: ['geocode']
        }, result => {
          let str = '';
          result.forEach((a, i) => {
            str += '<li><a href="javascript:myApp.exploreGoToMap(\'' + a.place_id + '\');">' + a.description + '</a></li>';
          });
          $('#explore-result-list').html(str);
          $('.explore-links-list').removeClass('hidden');
        });
      } else {
        $('#explore-result-list').html('');
        $('.explore-links-list').addClass('hidden');
      }
    });
    map.on('moveend', () => {
      self.getPoints();
    });
    this.getPoints(latlng);
  },

  data() {
    return {
      lng: lng,
      items: []
    };
  },

  methods: {
    zoomIn() {
      myApp.exploreMap.zoomIn();
    },

    zoomOut() {
      myApp.exploreMap.zoomOut();
    },

    goToMap(idx) {
      const $ = this.$,
            app = this.$app,
            map = myApp.homeMap;
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({
        placeId: idx
      }, (a, b) => {
        if (b !== 'OK') return;
        $('.explore-links-list').addClass('hidden');
        myApp.latlng = [a[0].geometry.location.lat(), a[0].geometry.location.lng()];
        myApp.homeReload = true;
        myApp.exploreMap.flyTo(myApp.latlng, 12);
      });
    },

    getZones() {
      const self = this,
            app = this.$app,
            $ = this.$;
      const map = myApp.exploreMap;
      const icons = myApp.icons;
      const bounds = map.getBounds();
      const zoom = map.getZoom();
      myApp.exploreGetZones = true;
      let b = 'ne_lat=' + bounds._northEast.lat + '&ne_lng=' + bounds._northEast.lng + '&sw_lat=' + bounds._southWest.lat + '&sw_lng=' + bounds._southWest.lng;

      if (myApp.realPosition) {
        b += '&lat=' + myApp.realPosition[0] + '&lng=' + myApp.realPosition[1];
      }

      let type = '';

      if (myApp.lastCategory) {
        type = '&type=' + myApp.lastCategory;
      }

      myApp.searchFilters = {
        viewAll: $('.subcategories-all').prop('checked'),
        subtypes: [],
        filters: []
      };

      if (myApp.searchFilters && myApp.searchFilters.viewAll === false) {
        $('[name=subcategories-checkbox]:checked').each(function () {
          myApp.searchFilters.subtypes.push($(this).val());
        });
      }

      $('[name=filters-checkbox]:checked').each(function () {
        myApp.searchFilters.filters.push($(this).val());
      });
      const range = app.range.get('.lgbtq');
      const lgbtq = '&lgbt=' + range.getValue();
      const subtypes = '&' + app.utils.serializeObject(myApp.searchFilters);
      const withpromo = $('.with-promo').prop('checked') ? '&promo=1&promot=' + $('[name="offers-date"]:checked').val() : '';
      const withdate = $('.with-promo').prop('checked') ? '&promod=' + $('#offers-date-calendar').val() : '';
      const withtakeaway = $('.with-takeaway').prop('checked') ? '&takeaway=1' : '';
      const withdelivery = $('.with-delivery').prop('checked') ? '&delivery=1' : '';
      myApp.server.get('imc/cluster/?' + b + type + subtypes + '&zoom=' + zoom + withpromo + withdate + withtakeaway + withdelivery + lgbtq).then(resp => {
        this.removePoints();
        resp.forEach(o => {
          let divIcon = L.divIcon({
            html: '<div class="marker-badge marker-badge-' + myApp.lastCategory + ' marker-badge-' + (o.counter < 10 ? 'small' : o.counter > 50 ? 'large' : 'normal') + '">' + o.counter + '</div>'
          });
          let m = L.marker([o.latitude, o.longitude], {
            icon: divIcon
          }).addTo(map).on('click', function (ev) {
            map.setView([o.latitude, o.longitude], zoom + 2);
          });
          myApp.exploreMarkersObj.push(m);
        });
        return self.$setState({
          items: []
        });
      }).catch(err => console.log(err, 'getInBounds:error'));
      $('.explore-links-list').addClass('hidden');
    },

    getPoints() {
      if (myApp.exploreMap.getZoom() < 10) return this.getZones();
      const self = this,
            app = this.$app,
            $ = this.$;
      const map = myApp.exploreMap;
      const icons = myApp.icons;
      const bounds = map.getBounds();
      const zoom = map.getZoom();
      let b = 'ne_lat=' + bounds._northEast.lat + '&ne_lng=' + bounds._northEast.lng + '&sw_lat=' + bounds._southWest.lat + '&sw_lng=' + bounds._southWest.lng;

      if (myApp.realPosition) {
        b += '&lat=' + myApp.realPosition[0] + '&lng=' + myApp.realPosition[1];
      }

      let type = '';

      if (myApp.lastCategory) {
        type = '&type=' + myApp.lastCategory;
      }

      myApp.searchFilters = {
        viewAll: $('.subcategories-all').prop('checked'),
        subtypes: [],
        filters: []
      };

      if (myApp.searchFilters && myApp.searchFilters.viewAll === false) {
        $('[name=subcategories-checkbox]:checked').each(function () {
          myApp.searchFilters.subtypes.push($(this).val());
        });
      }

      $('[name=filters-checkbox]:checked').each(function () {
        myApp.searchFilters.filters.push($(this).val());
      });
      const range = app.range.get('.lgbtq');
      const lgbtq = '&lgbt=' + range.getValue();
      const subtypes = '&' + app.utils.serializeObject(myApp.searchFilters);
      const withpromo = $('.with-promo').prop('checked') ? '&promo=1&promot=' + $('[name="offers-date"]:checked').val() : '';
      const withdate = $('.with-promo').prop('checked') ? '&promod=' + $('#offers-date-calendar').val() : '';
      const withtakeaway = $('.with-takeaway').prop('checked') ? '&takeaway=1' : '';
      const withdelivery = $('.with-delivery').prop('checked') ? '&delivery=1' : '';
      myApp.server.get('imc/inbounds/?' + b + type + subtypes + withpromo + withdate + withtakeaway + withdelivery + lgbtq).then(resp => {
        if (myApp.exploreGetZones) {
          myApp.exploreGetZones = false;
          this.removePoints();
        }

        resp.forEach(o => {
          if (myApp.exploreMarkers.indexOf(o.id1) > -1) return;
          if (o.subscription < 0) return;
          let discount = 0;
          let event = false;
          let iconType = 'offer';

          if (o.offers.length) {
            for (let i = 0; i < o.offers.length; i++) {
              if (o.offers[i].type == 'discount' && o.offers[i].discount * 1 > discount) discount = o.offers[i].discount * 1;else if (o.offers[i].type == 'event') event = true;
            }
          }

          myApp.exploreMarkers.push(o.id1);
          const k = 'subscription-' + o.subscription + (o.offers.length > 0 && o.type !== 'disco' ? '-offer' : '');
          const k1 = o.type;
          let text = '';

          if (discount && event) {
            iconType = 'mixed';
            text = '<i class="f7-icons" style="font-size: 10px">star_fill</i><br>' + discount + '%';
          } else if (discount) {
            text = discount + '%';
          } else if (event) {
            text = o.type === 'festival' ? '<i class="f7-icons">staroflife_fill</i>' : 'HAPPY';
          }

          let divIcon = L.divIcon({
            html: '<div class="icon-' + iconType + ' icon-offer-' + k1 + '">' + text + '</div>',
            iconSize: [40, 24],
            iconAnchor: [20, 28]
          });
          let m = L.marker(o.latlng, {
            icon: o.offers.length > 0 && o.type !== 'disco' ? divIcon : icons[k][k1],
            zIndexOffset: o.subscription * 1 > 0 ? 1001 : 0
          }).addTo(map).on('click', function (ev) {
            const el = $('[data-slideid="' + o.id + '"]');
            const idx = el.data('idx');
            const g = app.swiper.get('.explore-swiper');
            g.slideTo(idx, 0);
          });

          if (o.subscription * 1 > 0) {
            const mb = L.marker(o.latlng, {
              icon: myApp.iconBg
            }).addTo(map);
            myApp.homeMarkersObj.push(mb);
          }

          myApp.exploreMarkersObj.push(m);
        });
        return self.$setState({
          items: resp
        });
      }).then(() => {
        app.swiper.destroy('.explore-swiper');
        app.swiper.create({
          el: '.explore-swiper',
          spaceBetween: 5,
          slidesPerView: "auto"
        });
      }).catch(err => console.log(err, 'getInBounds:error'));
      $('.explore-links-list').addClass('hidden');
    },

    selectCategory(category) {
      const self = this,
            $ = this.$,
            app = this.$app;
      myApp.homeReload = true; // apre sottocategorie

      this.$root.$setState({
        type: category,
        subtypes: myApp.categories[category]
      }, () => {
        // controlla ultima categoria e seleziona tutti se categoria diversa
        if (myApp.lastCategory != category) {
          $('.subcategories-all').prop('checked', true);
          $('[name=subcategories-checkbox]').each(function () {
            $(this).prop('checked', false).on('change', () => {
              $('.subcategories-all').prop('checked', false);
            });
          });
          const range = this.$app.range.get('.lgbtq');
          range.setValue(0);
          $('[name=filters-checkbox]').prop('checked', false); // imposta ultima categoria selezionata

          myApp.lastCategory = category;
        }

        myApp.filter = this.filter; // apre panel right

        app.panel.open('right');
      });
    },

    filter() {
      this.removePoints();
      this.getPoints();
    },

    reset() {
      myApp.homeReload = true;
      myApp.searchFilters = null;
      myApp.lastCategory = '';
      this.$('.with-promo').prop('checked', false);
      this.$('#only-offers-dates').addClass('hidden');
      this.$('.with-takeaway').prop('checked', false);
      this.$('.with-delivery').prop('checked', false);
      const range = this.$app.range.get('.lgbtq');
      range.setValue(0);
      this.removePoints();
      this.getPoints();
    },

    goToMyPosition() {
      const self = this,
            app = this.$app,
            $ = this.$;
      const map = myApp.exploreMap;
      const options = {
        maximumAge: 3000,
        timeout: 30000,
        enableHighAccuracy: true
      };
      navigator.geolocation.getCurrentPosition(res => {
        myApp.latlng = [res.coords.latitude, res.coords.longitude];
        myApp.realPosition = [res.coords.latitude, res.coords.longitude];
        map.flyTo(myApp.latlng, 10);

        if (!myApp.exploreMarker) {
          myApp.exploreMarker = L.marker([res.coords.latitude, res.coords.longitude], {
            icon: myApp.GeoIcon
          });
          myApp.exploreMarker.addTo(map);
        } else {
          myApp.exploreMarker.setLatLng([res.coords.latitude, res.coords.longitude]);
        }
      }, err => {
        app.toast.show({
          text: err.message,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
      }, options);
    },

    removePoints() {
      // rimuove tutti i marker
      myApp.exploreMarkers = [];

      for (let i = 0; i < myApp.exploreMarkersObj.length; i++) {
        myApp.exploreMap.removeLayer(myApp.exploreMarkersObj[i]);
      }

      myApp.exploreMarkersObj = [];
    },

    goToDetail(id, type, subscription, id1) {
      if (type === 'festival') {
        myApp.currentPoi = this.items.reduce((e, i) => {
          if (e.id1 === id1) return e;else return i;
        });
        return this.goToPromo(id, id1, 'festival');
      }

      let page = type === 'disco' && subscription > 0 ? '/disco/' : '/detail/';
      this.$router.navigate(page + id + '/', {
        transition: 'f7-flip' // f7-cover, f7-circle, 

      });
    },

    goToPromo(a, b, type) {
      const url = type === 'disco' || type === 'festival' ? '/poi-event/' + a + '/' + b + '/?from=id' : '/detail/' + a + '/?offer=' + b;
      this.$router.navigate(url, {
        transition: 'f7-flip' // f7-cover, f7-circle, 

      });
    }

  },
  id: '4a8a016a26',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left">\n          <a href="/">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="right">\n          <!-- input Search -->\n          <div id="exploreInputSearch">\n            <i class=\'icon f7-icons\'>search</i>\n          </div>\n          <input id="explore-input" type="text" placeholder="';
      r += c(ctx_1.lng.homeSearchInput, ctx_1);
      r += '">\n          <span class="input-clear-button explore-clear-button"></span>\n        </div>\n        <!--<div class="right">\n          <a href="#" @click="reset" class="link icon-only">\n            <i class="icon f7-icons">arrow_counterclockwise</i>\n          </a>\n        </div>-->\n      </div>\n    </div>\n\n    <div class="page-content" id="explore-content">\n\n      <!-- Search result list -->\n      <div class="list links-list explore-links-list inset hidden" style="margin-top:0; max-width: 90vw">\n        <ul id="explore-result-list"></ul>\n      </div>\n\n      <!-- Mappa -->\n      <div id="explore-map"></div>\n\n      <!-- bootons zoom -->\n      <div class="menu-explore">\n        <div class="menu">\n          <div class="menu-inner">\n            <a href="#" class="menu-item">\n              <div @click="zoomOut" class="menu-item-content">\n                <i class="icon f7-icons">zoom_out</i>\n              </div>\n            </a>\n            <a href="#" class="menu-item">\n              <div @click="zoomIn" class="menu-item-content">\n                <i class="icon f7-icons">zoom_in</i>\n              </div>\n            </a>\n            &nbsp;&nbsp;&nbsp;\n            <a href="#" class="menu-item bg-color-blue menu-circle link popup-open" data-popup=".popup-poi-completi">\n              <div class="menu-item-content">\n                <i class="icon f7-icons">info</i>\n              </div>\n            </a>\n          </div>\n        </div>\n\n        <!-- FAB SX\n        <div class="fab fab-left-top color-black">\n          <a href="#" @click="reset">\n            <i class="icon f7-icons">arrow_2_circlepath</i>\n            <i class="icon f7-icons">arrow_2_circlepath</i>\n          </a>\n        </div> -->\n        <!-- FAB DX -->\n        <div class="fab fab-right-top color-imc">\n          <a href="#" @click="goToMyPosition">\n            <i class="icon material-icons">gps_fixed</i>\n            <i class="icon material-icons">gps_fixed</i>\n          </a>\n        </div>\n\n        <!-- Gallery -->\n        <div id="explore-gallery">\n          <div class="swiper-container explore-swiper">\n            <div class="swiper-wrapper"> \n              ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.items, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <div class="swiper-slide" data-slideid="';
          r += c(ctx_2.id, ctx_2);
          r += '" data-idx="';
          r += c(data_2 && data_2.index, ctx_2);
          r += '">\n                <div @click="goToDetail(\'';
          r += c(ctx_2.id, ctx_2);
          r += '\',\'';
          r += c(ctx_2.type, ctx_2);
          r += '\',\'';
          r += c(ctx_2.subscription, ctx_2);
          r += '\',\'';
          r += c(ctx_2.id1, ctx_2);
          r += '\')"  class="swiper-slide explore-h-slider">\n\n                  ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.avgStars, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                  <div class="explore-h-slider-stars">\n                    ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.stars, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                    <i class="icon f7-icons">';
                  r += c(ctx_4, ctx_4);
                  r += '</i>\n                    ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                  </div>\n                  ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                  <div class="explore-h-slider-image" \n                       style="background-image: url(';
          r += Template7Helpers.js_if.call(ctx_2, "this.images.length > 0", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += c(ctx_3.images[0].url, ctx_3);
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\'static/demo/';
              r += c(ctx_3.type, ctx_3);
              r += '.jpg\'';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += ')">\n                  </div>\n                  <div class="explore-h-slider-info">\n                    <div class="explore-h-slider-title">\n\n                      <div>';
          r += c(ctx_2.caption, ctx_2);
          r += '</div>\n\n                      ';
          r += Template7Helpers.js_if.call(ctx_2, "this.type === 'festival'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n\n                      ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n\n                      ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.events, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      ';
                  r += Template7Helpers.if.call(ctx_4, data_4 && data_4.first, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                      <div class="favorites-offer favorites-offer-discount-small">\n                        <small>HAPPY</small>\n                      </div>\n                      ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                      ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                      ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.discounts, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      ';
                  r += Template7Helpers.if.call(ctx_4, data_4 && data_4.first, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                      <div class="favorites-offer favorites-offer-discount-small">\n                        ';
                      r += c(ctx_5.discount, ctx_5);
                      r += '%\n                      </div>\n                      ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '\n                      ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n\n                      ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.info.takeaway, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      <img width="24" style="vertical-align: middle; border-radius: 5px; " src="static/menu/takeaway.png" alt=""/>\n                      ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                      ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.info.delivery, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      <img width="24" style="vertical-align: middle; border-radius: 5px" src="static/menu/delivery.png" alt=""/>\n                      ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n\n                      ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n\n                    </div>\n                    <div class="explore-h-slider-address">\n                      <div>\n                        ';
          r += Template7Helpers.js_if.call(ctx_2, "this.type === 'festival'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <span>';
              r += Template7Helpers.js.call(ctx_3, "myApp.categories['festival'][1]", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span> <br>\n                        ';
              r += c(ctx_3.address, ctx_3);
              r += '\n                        ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.subtypes, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += ' \n                        <span class="';
                      r += Template7Helpers.js.call(ctx_5, "this == ../../subtypeX && this != 0 ? 'badge color-imc' : ''", {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '">\n                          ';
                      r += Template7Helpers.js.call(ctx_5, "!isNaN(this) ? myApp.categories[ ../../type ][ this ] : lng.deliveryTypes[ this ]", {
                        hash: {},
                        data: data_5 || {},
                        fn: function empty() {
                          return '';
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '\n                        </span>\n                        ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += ' \n                        ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                        ';
                  r += c(ctx_4.address, ctx_4);
                  r += '\n                        ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' \n                        ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                      </div>\n\n                    </div>\n                    ';
          r += Template7Helpers.js_if.call(ctx_2, "this.type === 'festival'", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="explore-h-slider-description">';
              r += c(ctx_3.description_short, ctx_3);
              r += '</div>\n                    ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                    <div class="explore-h-slider-description">';
              r += c(ctx_3.description, ctx_3);
              r += '</div>\n                    ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                  </div>\n                </div>\n              </div> \n              ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            </div>\n          </div>\n        </div>\n\n        <!-- Explore buttons -->\n        <div id="explore-buttons">\n          <div class="row">\n            <div class="col">\n              <a href="#" @click="selectCategory(\'restaurant\')"><img class="responsive br-10" src="static/restaurant.png" alt=""/></a>\n            </div>\n            <div class="col">\n              <a href="#" @click="selectCategory(\'bar\')"><img class="responsive br-10" src="static/bar.png" alt=""/></a>\n            </div>\n            <div class="col">\n              <a href="#" @click="selectCategory(\'beach\')"><img class="responsive br-10" src="static/beach.png" alt=""/></a>\n            </div>\n            <div class="col">\n              <a href="#" @click="selectCategory(\'disco\')"><img class="responsive br-10" src="static/disco.png" alt=""/></a>\n            </div>\n            <div class="col">\n              <a href="/food-delivery/"><img class="responsive br-10" src="static/food-delivery.png" alt=""/></a>\n            </div>\n          </div>\n        </div>\n      </div>\n\n    </div>\n\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    